import { render } from "./ProxyMultisigAccountComponent.vue?vue&type=template&id=2da201fd&scoped=true"
import script from "./ProxyMultisigAccountComponent.vue?vue&type=script&lang=js"
export * from "./ProxyMultisigAccountComponent.vue?vue&type=script&lang=js"

import "./ProxyMultisigAccountComponent.vue?vue&type=style&index=0&id=2da201fd&lang=css"
import "./ProxyMultisigAccountComponent.vue?vue&type=style&index=1&id=2da201fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da201fd"]])

export default __exports__